import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCardNfc: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="credit-card-nfc, card, payment"><path d="M12.25 19.25H2.75V4.75H21.25V10.25H3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.293 20C19.293 18.5042 20.5055 17.2917 22.0013 17.2917" stroke="currentColor" strokeWidth="1.625"/><path d="M15.5 20C15.5 16.4101 18.4101 13.5 22 13.5" stroke="currentColor" strokeWidth="1.625"/></CentralIconBase>;
};

export default IconCreditCardNfc;
